// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1smQY","rootSuccess":"CompleteLink_rootSuccess__3ZPSo","rootFailure":"CompleteLink_rootFailure__14xBR","isDisabled":"CompleteLink_isDisabled__39IlU"};